<template>
  <div>
    <div>
      <h2>{{ title }}</h2>
      <table class="table" :class="tableClass">
        <thead>
          <slot name="columns">
            <th v-for="column in columns" :key="column">{{ column }}</th>
            <th>Image</th>
            <th>Action</th>
          </slot>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <slot :row="item">
              <td v-for="(column, index) in columns" :key="index">
                {{ itemValue(item, column) }}
              </td>
              <td>
                <!-- <span>
                   src="https:mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(121).webp"
              </span> -->
                <img :src="'http://localhost:8000' + item.image" alt="" width="70px" height="70px" class="rounded" />
              </td>
              <td>
                <label class="switch">
                  <input type="checkbox" checked v-if="item.status == 1"
                    @change="changeStatus(item.idBD, item.site, true)" />
                  <input type="checkbox" v-else @change="changeStatus(item.idBD, item.site, false)" />
                  <span class="slider round"></span>
                </label>
                <button class="btn btn-success" @click="goToPayment(item.idBD, item.site)" v-if="item.site !== 'car'"><i
                    class="ti-wallet"></i></button>

              </td>


            </slot>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import API from "../services/api-request.js";
export default {
  name: "paper-table",
  props: {
    columns: Array,
    data: Array,
    type: {
      type: String, // striped | hover
      default: "striped",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
    deleteService(identifier, site) {
      if (site == "tour") {
        identifier;
        const swalWithBootstrapButtons = this.$swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            title: "Êtes vous sûres ?",
            text: "Cet action sera irreversible!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI, Supprimer!",
            cancelButtonText: "Non, Annuler!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              API.destroy(identifier)
                .then((response) => {
                  swalWithBootstrapButtons.fire(
                    "Supprimé!",
                    "Ce site a été suprimé.",
                    "success"
                  );
                  location.reload();
                })
                .catch((error) => {
                  swalWithBootstrapButtons.fire(
                    "Desolé !",
                    "Une erreur s'est produite",
                    "Verifiez votre connexion et réessayez ."
                  );
                });
            } else {
              swalWithBootstrapButtons.fire(
                "Annulé !",
                "Vos données sont toujours disponible"
              );
            }
          });
      }

    },
    changeStatus(id, site, status) {

      status == true ?
        API.destroy(id, site).then((response) => {
        }) : API.update(id, { status: 1 }, site).then((response) => {
        });
    },

    goToPayment(id, site) {
      this.$router.push(`/payment/${site}/${id}`);
    },
  },
};
</script>
<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
